import { lazy } from 'react'
import './index.less'

export default lazy(() => import('./PrivateLine'))